import { useState } from "react";
import toast from "react-hot-toast";
import { Button, Label, Modal, TextInput } from "flowbite-react";
import { createList } from "../../api/instagram";

const CreateModal = ({ openModal, setOpenModal, refreshLists }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      toast.error('Name cannot be empty');
      return;
    }

    setLoading(true);

    try {
      await createList({ name });
      await refreshLists();

      toast.success(`${name} has been created successfully`);
      setName('');
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || error.message || 'An error occurred while creating the list.');
    } finally {
      setLoading(false);
      setOpenModal(false);
    }
  }

  return (
    <Modal show={openModal} size="md" onClose={() => setOpenModal(false)} popup>
      <Modal.Header />
      <Modal.Body>
        <form onSubmit={handleSubmit} className="space-y-6">
          <h3 className="text-xl font-medium text-gray-900">Create list</h3>
          <div>
            <div className="mb-2 block">
              <Label htmlFor="name" value="Name" />
            </div>
            <TextInput
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              placeholder="Enter list name"
            />
          </div>
          <div className="w-full">
            <Button
              type="submit"
              disabled={loading}
              isProcessing={loading}
            >
              Create
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

export default CreateModal;